module.exports = __webpack_public_path__ + "media/images/powerpoint/kantar-background-c16a2b5ed2b21d1969546b4a166bb1c8.png";